/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

Handlebars.registerHelper('ifCond', function(v1, v2, options) {
  if(v1 == v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      // console.log("addItemFromForm", callback, line_item);
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.get('/cart?view=json', function (cart, textStatus) {
    cart = JSON.parse(cart);
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItemId = function(id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, setCartContainer, getCartContainer;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : '#CartCount',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : true, // JSB disabled
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);

    if ($(window).width() >= 500) //1280 - 15
      setCartContainer('#CartDropdown');

    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    
    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  setCartContainer = function(cartContainer) {
    $cartContainer = $(cartContainer);
  };

  getCartContainer = function() {
    return $cartContainer;
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html('( ' + cart.item_count + ' )');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
      else {
        $cartCountSelector.removeClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat).replace('.00', ''));
    }
  };

  formOverride = function ($form) {

    // Optionally pass this in so we can call it from vonH.js
    if ($form)
      $formContainer = $form;

    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');
// console.log('formOverride', $form, evt.target, $addToCart );
      // Remove any previous quantity errors
      $('.qty-error').remove();
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    window.lastAddedProduct = product;
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
    // try {
    //   BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    // }
    // catch (e) {
    //   console.log('Error calling BOLD_COMMON_cart_loaded', e);
    // }
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<a href="#" class="close"><span class="sprite sprite-close sprite-small">Close</span></a>')
        .append('<h4 class="serif">' + "Your Cart is Empty" + '</h4>')
        .append('<a href="/collections/technik-leather" class="btn btn--full" style="margin-top:25px;">Shop Now</a>');
      cartCallback(cart);
      return;
    }

    // var templateSelector = '#CartTemplate';

    // Get the appropriate template for desktop
    // if (getCartContainer().selector == '#CartDropdown')
      var templateSelector = '#CartTemplateDropdown';

    // Handlebars.js cart layout
    var itemCount = 0,
        saleItem = false,
        items = [],
        item = {},
        data = {},
        totalPrice = 0,
        discountAmount = "0.5",
        source = $(templateSelector).html(),
        template = Handlebars.compile(source),
        promo = {'defaultMessage':"",'enabled':true,'promoCode':"JUSTFORYOU",'couponLink':"\u003ca class=\"add-coupon-link\" aria-label=\"Click code to apply\" data-label=\"Click code to apply\" href=\"\/discount\/JUSTFORYOU?redirect=%2Fcart\"\u003eJUSTFORYOU\u003c\/a\u003e",'cartMin':19500,'headerMessage':"Add $XX more to qualify for free gift!",'headerMessageApplies':"You qualify for a free gift!"};

  var headerMessage = promo.defaultMessage;

  var promoApplies = false;
  var hasPromoItem = false;

  // console.log('cart', cart);

  $.each(cart.items, function(index, cartItem) {
    // console.log('cartItem', cartItem);
    if (cartItem.meta.promoApplies) {
      promoApplies = true;
    }
    if (cart.promo_variants.indexOf(cartItem.variant_id) >= 0) {
      hasPromoItem = true;
    }
  });

  var campaignKeyword = 'GWP';

  // console.log('promoApplies', promoApplies, 'hasPromoItem', hasPromoItem, 'campaignKeyword', campaignKeyword, 'window.campaign', window.campaign);
  if (!(promoApplies && window.campaign && window.campaign.toUpperCase().search(campaignKeyword) >= 0)) {
    promo.enabled = false;
  }

  // console.log('promo.enabled',promo.enabled, promo.cartMin, cart.original_total_price);

  if (promo.enabled && cart.original_total_price > 0) {
    promo.priceDelta = promo.cartMin - cart.original_total_price;

    if (promo.cartMin > cart.original_total_price) {
      headerMessage = promo.headerMessage.replace('$XX', '$' + promo.priceDelta / 100);
    }
    else {
      headerMessage = promo.headerMessageApplies.replace('$XX', '$' + (promo.priceDelta / 100).toFixed(2).replace('.00', ''));
    }

  }

  // console.log('headerMessage', headerMessage);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      var discountPrice = '',
          saleItem = false,
          linePrice = cartItem.line_price;

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.product_title == 'Personalization') {
        var prodImg = null;
      } else if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_340x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var price = Shopify.formatMoney(cartItem.price * cartItem.quantity, settings.moneyFormat).replace('.00', '');
      var comparePrice = cartItem.price * cartItem.quantity;

      if (cartItem.line_price != cartItem.price * cartItem.quantity) {
        saleItem = true;
        price = '<s>' + Shopify.formatMoney(cartItem.line_price, settings.moneyFormat).replace('.00', '') + '</s> ' + price;
      }
      else if (cartItem.line_price != cartItem.original_line_price) {
        saleItem = true;
        // price = '<s>' + Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat).replace('.00', '') + '</s> ' + price;
        price = '&nbsp;' + Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat).replace('.00', '') + '&nbsp;';
        discountPrice += '<span class="discounted_price">';
        discountPrice += Shopify.formatMoney(cartItem.line_price, settings.moneyFormat).replace('.00', '');
        discountPrice += '</span>';
      }


      if (cartItem.line_price != cartItem.original_line_price) {
        for (var i = 0; i < cartItem.discounts.length; i++) {
          discountPrice += '<small>' + cartItem.discounts[i].title + '</small>';
        }
      }
     
      // console.log('cartItem', cartItem);
      // console.log('item', cartItem.product_title, saleItem, discountAmount, false);


      if (cartItem.compare_at_price) {
        comparePrice = cartItem.compare_at_price * cartItem.quantity;
        price = '&nbsp;' + Shopify.formatMoney(comparePrice, settings.moneyFormat).replace('.00', '') + '&nbsp;';
        discountPrice += '<span class="discounted_price">';
        discountPrice += Shopify.formatMoney(linePrice, settings.moneyFormat).replace('.00', '');
        discountPrice += '</span>';
      }

      

      var suffix = cartItem.product_title.split(' - ').pop();
      // console.log('suffix', suffix, 'Sample Sale,vH Revival'.includes(suffix));
      if ('Sample Sale,vH Revival'.includes(suffix)) {
        discountPrice += '<small>' + suffix + '</small>';
      }

      itemCount += cartItem.quantity;
      totalPrice += linePrice;
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.id,
        sku: cartItem.sku,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title.replace(' - Sample Sale', '').replace(' - vH Revival', ''),
        subtitle: cartItem.meta.subtitle ? cartItem.meta.subtitle.replace('Technik-Leather in ', '') : '',
        variation: cartItem.options[0] != 'Title' ? cartItem.variant_options[0] : '',
        properties: cartItem.properties,
        isPersonalization: cartItem.product_title == "Personalization" ? true : false,
        initials: cartItem.properties['_Initials'] || null,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        formattedPrice: price,
        formattedDiscountedPrice: discountPrice,
        comparePrice: comparePrice,
        price: linePrice,
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    itemCount = itemCount != 1 ? 'You have ' + itemCount + ' items in your bag' : 'You have ' + itemCount + ' item in your bag';

    // Gather all cart data and add to DOM
    data = {
      itemCount: itemCount,
      items: items,
      note: cart.note,
      totalPrice: totalPrice,
      headerMessage: headerMessage,
      totalPriceFormatted: Shopify.formatMoney(totalPrice, settings.moneyFormat).replace('.00', ''),
    }

    // console.log('data', data);

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
    if (typeof(updateCartPromo) == 'function') {
      updateCartPromo(cart);
    }
    if (typeof(updateCartPromoCode) == 'function') {
      updateCartPromoCode();
    }
    if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
      mlvedaload();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Remove all quantity from the item (delete item)
    $body.on('click', '.ajaxcart__qty-delete', function() {
      var $el = $(this),
          line = $el.data('line'),
          id = $el.data('id');

      var $item = $el.parents('.ajaxcart__row');

      // console.log("id", line, id);
      updateQuantity(id, 0);
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else if ($el.hasClass('ajaxcart__qty--delete')) {
        qty = 0;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-id, update the cart.
      // Otherwise, just update the input's number
      // if (id) {
      //   updateQuantity(id, qty);
      // } else {
      // JSB: just update the selector because its onchange calls updateQuantity()
        $qtySelector.val(qty);
      // }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          id = $el.data('id'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-id, update the cart
      if (id) {
        updateQuantity(id, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function getMonogramForItem($item_row) {
      let products = Array.from(document.querySelectorAll('.ajaxcart__inner .ajaxcart__row'));
      let monogram = products.filter((product) => { let ds = product.dataset; return ds.sku == 'MONOGRAMMING' && ds.initials == $item_row.data('initials') });
      if (monogram.length) {
        return monogram[0];
      }
      else {
        return false;
      }
    }

    function updateQuantity(id, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-id="' + id + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      var monogramming = getMonogramForItem($row);

      if (monogramming) {

        // // Add activity classes when changing cart quantities
        // var $row_m = $('.ajaxcart__row[data-id="' + monogramming.dataset.id + '"]').addClass('is-loading');

        // if (qty === 0) {
        //   $row_m.parent().addClass('is-removed');
        // }

        console.log('monogramming', id, monogramming.dataset.id, monogramming);

        // Slight delay to make sure removed animation is done
        setTimeout(function() {
          ShopifyAPI.changeItemId(monogramming.dataset.id, qty, adjustCartCallback);
        }, 750);
        // Slight delay to make sure removed animation is done
        setTimeout(function() {
          ShopifyAPI.changeItemId(id, qty, adjustCartCallback);
        }, 250);
      }
      else {
        // Slight delay to make sure removed animation is done
        setTimeout(function() {
          ShopifyAPI.changeItemId(id, qty, adjustCartCallback);
        }, 250);
      }
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // console.log('cart', cart);

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]', $cartContainer);

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    setCartContainer: setCartContainer,
    getCartContainer: getCartContainer,
    formOverride: formOverride,
    updateCountPrice: updateCountPrice
  };

  return module;

}(ajaxCart || {}, jQuery));
